<template>
  <div>
    <!-- <div v-if="!showAccessories">
      <p class="ship-to ml-3 mb-2">{{ $t("OrderPage[\"Ship to\"]") }}</p>
      <div id="internation-shipping-select">
        <PatientCountrySelector
          :patient-country="'US'"
          :is-patient-update="false"
          @countryChange="countryChange"
        />
      </div>
      <CountryRestrictionAlert
        class="mt-2.5"
      />
    </div> -->
    <div 
      v-if="isShowFee || labProcessingFee > 0 || isShowSettingsProcessingFee || isMarkupEligible" 
      class="flex justify-between items-center mt-4"
    >
      <p class="fee-title">
        {{ $t("OrderPage[\"Tests Total:\"]") }}
      </p>
      <p class="fee-amount">{{ currency.symbol + orderTotal.toFixed(2) }}</p>
    </div>    
    <div v-if="isShowFee">
      <div v-loading="runningShippingFeeAPI">
        <div class="flex justify-between items-center">
          <p class="fee-title">{{ $t("OrderPage[\"Import Fee:\"]") }}</p>
          <p class="fee-amount">{{ currency.symbol + totalImportFee.toFixed(2) }}</p>
        </div>
        <div class="flex justify-between items-center">
          <p class="fee-title">{{ $t("OrderPage[\"Export Fee:\"]") }}</p>
          <p class="fee-amount">{{ currency.symbol + totalExportFee.toFixed(2) }}</p>
        </div>
      </div>
    </div>
    <!-- <p>{{ consultationFee }}</p> -->
    <div 
      v-if="(orderTotal > 0 || merchTotalPrice > 0) && showTransactionFee && consultationFee.amount > 0" 
      class="flex justify-between items-center"  
    >
      <p class="fee-title">{{ consultationFeeName }} </p>
      <div class="flex justify-start">
        <p class="fee-amount mr-2.5">{{ currency.symbol + consultationFee.amount.toFixed(2) }}</p>
        <div @click="editConsultationFeeCount++" class="cursor-pointer">
          <img src="@/assets/orderTest/order-page/edit_16px.svg" alt="">
        </div>
      </div>
    </div>
    <div v-if="labProcessingFee > 0" class="flex justify-between items-center">
      <div class="flex">
        <p class="fee-title">{{ $t("OrderPage[\"Lab Processing Fee:\"]") }}</p>
        <span 
          class="material-icons-outlined info-icon" 
          style="margin-top: 2.5px;"
          @click="centerDialogVisible = true">info
        </span>
        <labProcessingFeeDialog 
          :centerDialogVisible="centerDialogVisible"
          @close="centerDialogVisible = false"
        />
      </div>
      <p class="fee-amount">{{ currency.symbol + labProcessingFee.toFixed(2) }}</p>
    </div>
    <div v-if="conciergeFee && conciergeFee.isUse && conciergeFee.amount > 0" class="flex justify-between items-center">
      <p class="fee-title">Concierge Fee:</p>
      <p class="fee-amount">{{ currency.symbol + conciergeFee.amount.toFixed(2) }}</p>
    </div>
    <div v-if="isShowSettingsProcessingFee" class="mb-4">
      <div class="flex justify-between processing-fee">
        <div class="flex">
          <p>{{ $t("OrderPage[\"Lab Processing fee:\"]") }}</p>
          <!-- <el-popover trigger="click" placement="bottom" popper-class="processing-fee-info-popover">
            <p>
              A processing fee (${{ nonReturningLabProcessingFee }}) will be charged if an 
              order total cost less than the payment cap (${{ nonReturningCustomerCapFee }}). The  
              final cost will be the cap off value (${{ nonReturningCustomerCapFee }}) or 
              the sum (original price + ${{ nonReturningLabProcessingFee }}), whichever is lower. If 
              the same patient takes a test within a time range (from 7 days to 180 days) of the last test, the cap  
              off value (${{ returningCustomerCapFee }}) will be lower than the 
              regular (${{ nonReturningCustomerCapFee }}).
            </p>
            <template v-slot:reference>
              <span class="material-icons-outlined info-icon">info</span>
            </template>
          </el-popover> -->
          <span 
            class="material-icons-outlined info-icon" 
            @click="centerDialogVisible = true">info
          </span>
          <labProcessingFeeDialog 
            :centerDialogVisible="centerDialogVisible"
            @close="centerDialogVisible = false"
          />
        </div>
        <p>{{ currency.symbol + nonReturnPatientProcessingFeeCalcd.toFixed(2) }}</p>
      </div>
      <p class="processing-fee-gray">(Regular)</p>
      <p class="flex justify-end mt-3 processing-fee">{{ currency.symbol + returnPatientProcessingFeeCalcd.toFixed(2) }}</p>
      <p class="processing-fee-gray">(Same Patient Promotion)</p>
    </div>
    <TransactionConsultationFee
      v-if="showTransactionFee && (orderTotal > 0 || merchTotalPrice > 0)" 
      class="mb-2.5"
      :count="editConsultationFeeCount"
      :have-markup="isMarkupEligible && markupPrice > 0"
    />
    <div v-if="isMarkupEligible && markupPrice" class="flex justify-between mb-4">
      <p>{{ $t("OrderPage[\"Test Revenue:\"]") }}</p>
      <p>{{ currency.symbol + markupPrice.toFixed(2) }}</p>
    </div>
    <div v-if="merchTotalPrice > 0" class="flex justify-between mb-4" :class="isCalculatorPage ? 'mt-4' : ''">
      <p>{{ $t("OrderPage[\"Practice Product Revenue:\"]") }}</p>
      <p>{{ currency.symbol + merchTotalPrice.toFixed(2) }}</p>
    </div>
    <hr v-if="isShowFee || labProcessingFee > 0 || isShowSettingsProcessingFee || isMarkupEligible" class="divide-line">
  </div>
</template>

<script>
import _ from "lodash";
import { getInternationalShippingFee } from "@/api/va-order-page/pricing/shipping";
import { countryRestrictList } from "@/utils/va-order-test/index.js";
import PatientCountrySelector from "../../../patient-info/components/PatientCountrySelector.vue"
import CountryRestrictionAlert from "../../../../country-restriction-alert";
import TransactionConsultationFee from "./transaction-and-consultation-fee/TransactionConsultationFee.vue";
import { mapState, mapGetters } from "vuex";
import labProcessingFeeDialog from './labProcessingFeeDialog.vue'

export default {
  components: {
    PatientCountrySelector,
    CountryRestrictionAlert,
    labProcessingFeeDialog,
    TransactionConsultationFee,
  },

  props: {
    showAccessories: {
      type: Boolean,
      default: false,
    },    
    kitTypeList: {
      type: Array,
      default: () => [],
    },
    orderTotal: {
      type: Number,
      default: 0.0,
    },
    deliveryMethod: {
      type: Object,
      default: () => {},
    },
    labProcessingFee: {
      type: Number,
      default: 0,
    },
    processingAndCapOffValue: {
      type: Object,
      default: () => {},
    },
    nonReturnPatientProcessingFeeCalcd: {
      type: Number,
      default: 0,
    },
    returnPatientProcessingFeeCalcd: {
      type: Number,
      default: 0,
    },
    waiveLabProcessingFeeUser: {
      type: Boolean,
      default: false
    },  
    markupPrice: {
      type: Number,
      default: 0
    },
    merchTotalPrice: {
      type: Number,
      default: 0
    },
  },

  data() {
    return {
      country: "US",
      countryRestrictList,
      internationalShippingFee: {
          importFee: 0,
          exportFee: 0,
          total: 0
      },
      priceList: [],
      shippingChange: 0,
      intervalList: [],
      centerDialogVisible: false,
      editConsultationFeeCount: 0,
      hasInitConsultationFee: false,
      runningShippingFeeAPI: false
    }
  },

  computed: {
    ...mapState(["currency"]),
    ...mapState("orderTest", ["countryOptions", "isPatientInfoInSessionStorage", "defaultSettings", "isBackFromCheckoutPage"]),
    ...mapState("orderTest/user", ["patientCountry", "userInfo"]),
    ...mapState("orderTest/orderDraft", ["orderDraft"]),
    ...mapState("orderTest/order", ["plannedOrderList", "paymentMethod", "consultationFee", "conciergeFee"]),
    ...mapGetters("orderTest/order", ["isMarkupEligible"]),
    ...mapGetters("orderTest", ["selectedItemList"]),

    bloodDelivery() {
      if (!_.isEmpty(this.deliveryMethod)) {
        if (this.deliveryMethod.blood === "shipToPatient") {
          return 1
        }
      }
      return 0
    },

    nonBloodDelivery() {
      if (!_.isEmpty(this.deliveryMethod)) {
        if (this.deliveryMethod.nonBlood === "shipToPatient") {
          return 1
        }
      }
      return 0
    },

    isShowFee() {
      return (this.runningShippingFeeAPI || this.internationalShippingFee.total > 0.0) 
        && this.orderTotal > 0.0;
    },

    isShowSettingsProcessingFee() {
      return false;
    },

    nonReturningLabProcessingFee() {
      if (!_.isEmpty(this.processingAndCapOffValue)) {
        return this.processingAndCapOffValue.nonReturningLabProcessingFee;
      }
      return 0;
    },

    nonReturningCustomerCapFee() {
      if (!_.isEmpty(this.processingAndCapOffValue)) {
        return this.processingAndCapOffValue.nonReturningCustomerCapFee;
      }
      return 0;
    },

    returningCustomerCapFee() {
      if (!_.isEmpty(this.processingAndCapOffValue)) {
        return this.processingAndCapOffValue.returningCustomerCapFee;
      }
      return 0;
    },
    totalImportFee() {
      let plannedOrdersImportFee = this.plannedOrderList
        .reduce((acc, order) => acc + order.shippingFee.importFee, 0);
      return this.internationalShippingFee.importFee + plannedOrdersImportFee;
    },

    totalExportFee() {
      let plannedOrdersExportFee = this.plannedOrderList
        .reduce((acc, order) => acc + order.shippingFee.exportFee, 0);
      return this.internationalShippingFee.exportFee + plannedOrdersExportFee;
    },

    showTransactionFee() {
      if (_.isEmpty(this.userInfo)) {
        return false;
      }
      return ["patientPayNow", "patientPayLater"].includes(this.paymentMethod);
    },
    countryRestrictCodeList() {
      return this.countryRestrictList.map(country => country.code);
    },
    consultationFeeName() {
      if (!this.consultationFee || !this.consultationFee.name) {
        return this.$t("OrderPage[\"Consultation Fee:\"]");
      } else {
        return this.consultationFee.name + ":";
      }
    },
    isCalculatorPage() {
      return false;
    }
  },

  watch: {
    patientCountry(newVal){
      if (newVal) {
        this.countryChange(newVal)
      }
    },
    shippingChange(newVal, oldVal) {
      if (newVal >0){
        this.$emit("feeChange", this.internationalShippingFee.total);
      }
    },

    kitTypeList: {
      // if select discount panel
      // this value will change one by one with a initial status "shipToPatient"
      // need debounce watch to handle to final value
      handler: _.debounce(function (newVal) {
        this.checkShippingFee();
      }, 600),
      deep: true,
    },

    country() {
      this.checkShippingFee();
    },

    // bloodDelivery(newVal) {
    //   this.checkShippingFee();
    // },

    // nonBloodDelivery(newVal) {
    //   this.checkShippingFee();
    // },

    showTransactionFee(newVal) {
      if (!newVal || (newVal && this.consultationFee.amount > 0)) {
        this.$store.dispatch("orderTest/order/setConsultationFeeUsage", newVal);
      }
    },

    defaultSettings() {
      if (!this.hasInitConsultationFee) {
        this.initConsultationFee();
      }
    },
  },

  emits:["feeChange", "disableCheckout"],

  mounted() {
    this.country = this.patientCountry;
    this.initConsultationFee();
  },

  beforeUnmount() {
    this.priceList = [];
    this.internationalShippingFee = {
          importFee: 0,
          exportFee: 0,
          total: 0
    },
    this.intervalList.forEach((interval) => {
      clearInterval(interval);
    })
  },

  methods: {
    initializeIntervalAndCountry() {
      let patient = JSON.parse(sessionStorage.getItem("patient"));
      let interval = null
      if (this.showAccessories && patient) {
        interval = setInterval(() => {
            let patient = {}
            let localCountry = ""
            if (window.location.href.includes("ordertest/main") || window.location.href.includes("ordertest/draft")) {
              patient = JSON.parse(sessionStorage.getItem("patient"));
              localCountry = patient.country
            }
            // let patient = JSON.parse(sessionStorage.getItem("patient"));
            // let localCountry = patient.country
            if (localCountry) {
              this.country = localCountry
            }
        }, 1000);
        this.intervalList.push(interval);
      }
    },

    async checkShippingFee() {
      let countryFound = this.countryOptions.find(c => c.countryNameTwoBytes === this.country);
      const patient = JSON.parse(sessionStorage.getItem("patient"));
      const postalCode = patient && patient.zipcode ? patient.zipcode : "";

      // for international user (non US and non CA), apply import fees for all delivery methods
      // for us or ca user, always waive shipping fee 
      let isUSOrCA = countryFound && (countryFound.vibrantCountryId == "238" || countryFound.vibrantCountryId == "42")
      if (!countryFound || isUSOrCA) {
        this.priceList = [];
        this.updateImportExportFee();
        return;
      }

      // all the code below is for non us ca users
      // Apply import fees for all delivery methods (including Kit Provided by Office)
      const modifiedKitTypeList = [...this.kitTypeList];
      
      // if no kits to process, just set shipping fee to 0
      if (modifiedKitTypeList.length === 0) {
        this.priceList = [];
        this.updateImportExportFee();
        return;
      }
      let countryCode = countryFound.vibrantCountryId;
      const getShippingFee = getInternationalShippingFee;
      try {
        this.runningShippingFeeAPI = true;
        this.$emit("disableCheckout", true);
        const itemIdList = this.selectedItemList?.map(item => item.id).filter(Boolean) || [];
        const { data } = await getShippingFee({
          countryCode,
          kitTypeList: modifiedKitTypeList,
          postalCode,
          currency: this.currency.name.toLowerCase(),
          itemIdList
        });
        this.priceList = data ? data : [];
        this.updateImportExportFee();
        this.runningShippingFeeAPI = false;
        this.$emit("disableCheckout", false);
        // update planned orders if any
        // this.plannedOrderList.forEach((order, index) => {
        //   let updatedPlannedOrder = { ...order };
        //   updatedPlannedOrder.shippingFee = this.internationalShippingFee;
        //   this.$store.dispatch("orderTest/order/updatePlannedOrder", { index, updatedPlannedOrder });
        // });
        return;
      } catch (err) {
        this.runningShippingFeeAPI = false;
        this.$emit("disableCheckout", false);
        console.error(err);
      }

    },

    updateImportExportFee() {
        // calculate import shipping fee
        let importFee  = this.priceList
          .filter(p => p.fee_type === "IMPORT")
          .reduce((acc, t) => acc + Number(t.price), 0);
        // calculate export shipping fee
        let exportFee = this.priceList
          .filter(p => p.fee_type === "EXPORT")
          .reduce((acc, t) => acc + Number(t.price), 0);
        // calculate total
        let total = importFee + exportFee;
        this.$store.dispatch("orderTest/order/setShippingFee", { 
          importFee, exportFee, total 
        });
        this.internationalShippingFee = {
          importFee,
          exportFee,
          total
        };
        this.shippingChange++;
    },

    // pickBloodNonBlood(t) {
    //   if (t.tube_type.toLowerCase() === "blood") {
    //     return Number(t.price) * this.bloodDelivery;
    //   } 
    //   else {
    //     return Number(t.price) * this.nonBloodDelivery;
    //   }
    // },

    initConsultationFee() {
      if (this.hasInitConsultationFee || this.isBackFromCheckoutPage)  {
        return;
      }
      if (!_.isEmpty(this.orderDraft)) {
        if (!this.orderDraft.is_use_consultation_fee || !this.orderDraft.consultation_fee) {
          // if the draft has consultation fee, return because it will be set up in order page index
          // You cannot set it up here, because it should be setup after draft choose items
          return;
        }
      }
      if (this.defaultSettings && this.defaultSettings.consultation_fee && this.defaultSettings.consultation_fee != "0") {
        // let { amount, isUse } = this.consultationFee;
        const amount = parseFloat(this.defaultSettings.consultation_fee);
        const name = this.defaultSettings.consultation_fee_customized_name 
                      ? this.defaultSettings.consultation_fee_customized_name 
                      : this.$t("OrderPage[\"Consultation Fee\"]")
        const isUse = ["patientPayNow", "patientPayLater"].includes(this.paymentMethod);
        if (amount && amount > 0) {
          this.$store.dispatch("orderTest/order/setConsultationFee", { amount, isUse, name });
          this.hasInitConsultationFee = true;
        }
      }
    },

    countryChange(c){
      let country = "";
      if (typeof c === "object") {
        country = c.value
      } else {
        country = c
      }
      if (country != this.country) {
        this.country = country;
        this.checkShippingFee();
      }
    },
    
  },
}
</script>

<style scoped>
.divide-line {
  box-sizing: border-box;
  height: 1px;
  border: 1px solid #e6e6e6;
  margin-top: 4px;
  margin-bottom: 14px;
  position: relative;
  margin: 0 -12px;
}

.fee-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  letter-spacing: 0.4576px;
  color: #000000;
  margin-bottom: 10px;
}

.fee-amount {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  letter-spacing: 0.4576px;
  color: #000000;
  margin-bottom: 10px;
}

.processing-fee {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.4576px;
  color: black;
  height: 16px;
  align-items: center;
}

.processing-fee-gray {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.4576px;
  color: #767676;
  height: 14px;
  align-items: center;
  margin-top: 2px;
  display: flex;
  justify-content: flex-end;
}

.info-icon {
  margin-left: 3.5px;
  margin-top: 4.5px;
  font-size: 16px;
  cursor: pointer;
}

.fee-title-2 {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  letter-spacing: 0.4576px;
  color: #000000;
}

.fee-amount-2 {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  letter-spacing: 0.4576px;
  color: #000000;
}

.ship-to {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4004px;

  color: #000000;
}
</style>